import { useSyncExternalStore } from 'react';

// The focused Screen publishes the height of its pinned footer (banner slot,
// ActionDock and tab bar) so the root-level SyncStatusBanner floats above it
// instead of covering the primary button. Mirrors navigation/fieldTabBarHeight.js.
// Each Screen clears only its own entry, so a blur that runs after the next
// screen's focus cannot wipe the new height.
let owner = null;
let currentHeight = 0;
const listeners = new Set();

const notify = () => listeners.forEach(listener => listener());

export const setScreenFooterHeight = (ownerKey, height) => {
	const nextHeight = height || 0;
	if (owner === ownerKey && currentHeight === nextHeight) {
		return;
	}

	owner = ownerKey;
	currentHeight = nextHeight;
	notify();
};

export const clearScreenFooterHeight = (ownerKey) => {
	if (owner !== ownerKey) {
		return;
	}

	owner = null;
	currentHeight = 0;
	notify();
};

const subscribe = (listener) => {
	listeners.add(listener);
	return () => listeners.delete(listener);
};

export const getScreenFooterHeight = () => currentHeight;

export const useScreenFooterHeight = () => useSyncExternalStore(subscribe, getScreenFooterHeight);

// The other direction: the floating SyncStatusBanner publishes its own height (0 while
// hidden) so Screen can pad its body and the last content scrolls clear of the banner.
let syncBannerHeight = 0;
const syncBannerListeners = new Set();

export const setSyncBannerHeight = (height) => {
	const nextHeight = height || 0;
	if (nextHeight === syncBannerHeight) {
		return;
	}

	syncBannerHeight = nextHeight;
	syncBannerListeners.forEach(listener => listener());
};

const subscribeSyncBanner = (listener) => {
	syncBannerListeners.add(listener);
	return () => syncBannerListeners.delete(listener);
};

export const getSyncBannerHeight = () => syncBannerHeight;

export const useSyncBannerHeight = () => useSyncExternalStore(subscribeSyncBanner, () => syncBannerHeight);
